module.exports = __webpack_public_path__ + "static/media/Load-0.4aefd6c9.svg";